import { createSelector } from 'reselect';
import reportModel from '../../models/report';
import trainingPhaseModel from '../../models/training-phase';

const isAddingScheduledReport = state =>
  state.trainingPhases.isAddingScheduledReport;
const isEditingReport = state => state.trainingPhases.isEditingReport;
const isViewingReport = state => state.trainingPhases.isViewingReport;
const list = state => state.trainingPhases.list;
const reports = state => state.trainingPhases.reports;
const openReportList = state => state.reports.openReportList;
const myReports = state => state.reports.list;
const selectedGuid = state => state.trainingPhases.selectedGuid;

const getSelectedReport = (trainingPhaseReports, reportGuid, openReportList, myReports) => {
  let selected = !trainingPhaseReports
    ? null
    : trainingPhaseReports.find((report) => {
      return report.guid === reportGuid;
    });
  if(!selected) {
    selected = !openReportList
      ? null
      : openReportList.find((report) => {
        return report.guid === reportGuid;
      });
  }
  if (!selected) {
    return myReports
      ? myReports.find((report) => {
        return report.guid === reportGuid;
      }): null ;
  }
  return selected;
};

const addingScheduledReport = createSelector(
  [reports, isAddingScheduledReport, openReportList, myReports],
  getSelectedReport,
);

const closedPhases = createSelector([list], (phases) => {
  const closed = !phases
    ? null
    : phases.filter(phase => phase.status === 'closed');
  return !closed ? null : closed;
});

const editingReport = createSelector(
  [reports, isEditingReport, openReportList, myReports],
  getSelectedReport,
);

const pendingPhases = createSelector([list], (phases) => {
  const pending = !phases
    ? null
    : phases.filter(phase => phase.status === 'pending');
  return !pending ? null : pending;
});

const openedPhases = createSelector([list], (phases) => {
  const opened = !phases
    ? null
    : phases.filter(phase => phase.status === 'opened');
  return !opened ? null : opened;
});

const selectedTrainingPhase = createSelector(
  [list, selectedGuid],
  (phases, phaseGuid) => {
    const selected = !phases
      ? null
      : phases.find(phase => phase.guid === phaseGuid);
    return !selected ? null : trainingPhaseModel(selected);
  },
);

const viewingReport = createSelector(
  [reports, isViewingReport],
  getSelectedReport,
);

export default {
  addingScheduledReport,
  closedPhases,
  editingReport,
  openedPhases,
  pendingPhases,
  reportModel,
  selectedTrainingPhase,
  viewingReport,
};
